import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

export const ThreadGetParticipantInputsSchema = z.object({
  'thread-id': z.string().describe('ID of the thread'),
  routing: z
    .boolean()
    .optional()
    .describe('If true, get the routing participant of the thread'),
  'participant-id': z
    .string()
    .optional()
    .describe(
      'ID of a specific participant to retrieve (ignored if routing is true)',
    ),
})

export const ThreadGetParticipantCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/threads'),
    cmd: z.literal('thread.get-participant'),
    options: z.record(z.string(), z.unknown()).optional(),
  }),
  inputs: ThreadGetParticipantInputsSchema,
})

export type ThreadGetParticipantCommand = z.infer<
  typeof ThreadGetParticipantCommandSchema
>
